import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

/**
 * Klient nad `/v1/admin/flags/*` (@reos/flags, admin-flags.ts) - kroky O1 a
 * UX1 pouzivaji jen tenant override endpointy; admin UI resi dva flagy
 * (`pilot.menu`, `pilot.showHiddenSections`) pro tenant prihlaseneho admina.
 */

export const PILOT_MENU_FLAG_KEY = 'pilot.menu';
/** Krok UX1: skupina „Skrýt do napojení“ (AUD1 §3.3) — výchozí stav SKRYTO. */
export const PILOT_HIDDEN_SECTIONS_FLAG_KEY = 'pilot.showHiddenSections';

export interface FlagOverrideDto {
  readonly scope: 'tenant' | 'user';
  readonly subjectId: string;
  readonly flagKey: string;
  readonly enabled: boolean;
}

/** `null` = zadny tenant override (plati globalni default, viz migrace 0014 - OFF). */
export async function getTenantFlagOverride(tenantId: string, key: string): Promise<boolean | null> {
  const result = await unwrap(
    apiClient.GET('/v1/admin/tenants/{tenantId}/flags/{key}/overrides', { params: { path: { tenantId, key } } }),
  );
  const items = (result as { items: FlagOverrideDto[] }).items;
  const override = items.find((item) => item.scope === 'tenant' && item.subjectId === tenantId);
  return override ? override.enabled : null;
}

export async function setTenantFlag(tenantId: string, key: string, enabled: boolean): Promise<void> {
  await unwrap(
    apiClient.PUT('/v1/admin/tenants/{tenantId}/flags/{key}', {
      params: { path: { tenantId, key } },
      body: { enabled },
    }),
  );
}

/** Smaze tenant override - flag se vrati na globalni default. */
export async function clearTenantFlag(tenantId: string, key: string): Promise<void> {
  await unwrap(apiClient.DELETE('/v1/admin/tenants/{tenantId}/flags/{key}', { params: { path: { tenantId, key } } }));
}
